import React from "react";
import { Outlet } from "react-router-dom";

/**
 * A component that serves as a layout wrapper for drinking water tasks routes.
 * It uses React Router's Outlet component to render nested routes.
 * 
 * This page displays tasks filtered by drinking water customer type (Trinkwasser/schicht).
 * 
 * @component
 * @returns {JSX.Element} The rendered drinking water tasks page layout
 * 
 * @example
 * ```tsx
 * <DrinkingWaterTasksPage />
 * ```
 */
const DrinkingWaterTasksPage = () => {
  return <Outlet />;
};

export default DrinkingWaterTasksPage;

